import React from 'react';
import PropTypes from 'prop-types';

import { styled, up, css } from '@smooth-ui/core-sc';

import TopImg from './images/body-bg-top.jpg';
import BottomImg from './images/body-bg-bottom.jpg';

const BgImageContainer = styled.div`
  position: relative;
  height: 100%;
  min-height: ${props => (props.topOnly ? `927px;` : `1854px;`)};
  display: flex;
  flex-direction: column;
  margin-top: ${props => (props.noPadding ? `0;` : `-10px;`)};
  padding-top: ${props => (props.noPadding ? `0;` : `20px;`)};
  z-index: ${props => (props.noPadding ? `1;` : `0`)};

  ${up(
    'lg',
    css`
      padding-top: ${props => (props.noPadding ? `0;` : `110px;`)};
    `
  )};

  .bgTop,
  .bgBottom {
    background-image: url(${TopImg});
    height: 927px;
    position: absolute;
    width: 100%;
    z-index: -1;
  }

  .bgTop {
    top: 0;
  }

  .bgBottom {
    background-image: url(${BottomImg});
    bottom: 0;
    z-index: -1;
  }
`;

const BgImage = props => (
  <BgImageContainer {...props}>
    <div className="bgTop"></div>
    <>{props.children}</>
    {!props.topOnly && <div className="bgBottom"></div>}
  </BgImageContainer>
);

BgImage.propTypes = {
  topOnly: PropTypes.bool,
  noPadding: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

BgImage.defaultProps = {
  noPadding: false,
  topOnly: false,
};

export default BgImage;
